import { FileText, Mic, ShieldCheck, Puzzle, TrendingUp, Users } from "lucide-react";

export const reviewCategories = [
  {
    id: 1,
    key: "technical_skills",
    title: "Technical / Domain Knowledge",
    description: "Knowledge related to their field - Understanding of concepts and tools",
    icon: FileText,
    placeholder: "e.g. Strong in Python and React but lacks depth in system design...",
  },
  {
    id: 2,
    key: "communication",
    title: "Communication Skills",
    description: "Clarity of explanation · Listening ability · Verbal communication",
    icon: Mic,
    placeholder: "e.g. Explains concepts clearly with good examples...",
  },
  {
    id: 3,
    key: "confidence_level",
    title: "Confidence Level",
    description: "Confidence while answering · Presentation and body language",
    icon: ShieldCheck,
    placeholder: "e.g. Seemed nervous initially but settled in well...",
  },
  {
    id: 4,
    key: "problem_solving",
    title: "Problem Solving Ability",
    description: "Logical thinking · Approach to solving challenges",
    icon: Puzzle,
    placeholder: "e.g. Took a methodical approach but missed edge cases...",
  },
  {
    id: 5,
    key: "learning_ability",
    title: "Learning Ability / Adaptability",
    description: "Willingness to learn · Ability to adapt",
    icon: TrendingUp,
    placeholder: "e.g. Picked up new concepts quickly...",
  },
  {
    id: 6,
    key: "teamwork",
    title: "Teamwork / Collaboration",
    description: "Ability to work with others · Respect for team opinions",
    icon: Users,
    placeholder: "e.g. Gave strong examples of cross-functional collaboration...",
  },
];
